import { assetApiV2 } from '@src/libs/assetApiV2'
import { ITokenInfoResponse } from '@src/types/assetApiV2.types'

export const assetApiV2GetTokenInfo = async (chainName: string, address: string): Promise<ITokenInfoResponse> => {
    const { data } = await assetApiV2.get<ITokenInfoResponse>(`/token-info/${chainName}/${address}`)

    return data
}
